import { Alert } from '@dev/ee-components';
import { Link } from '@material-ui/core';
import React from 'react';
import { Trans } from 'react-i18next';

export const StripePolicyChangeAlert = () => (
    <Alert
        severity="error"
        body={
            <Trans
                i18nKey="stripepolicychange_alert"
                components={{
                    l: <Link href="mailto:support@elasticemail.com" />,
                }}
            />
        }
    />
);
